export const actionTypes = {
  CREATE: 'create',
  SET: 'set',
  VIEW: 'view',
  CLOSE: ''
};
